import { render } from "./Demo3.vue?vue&type=template&id=96a89fe8&scoped=true&ts=true"
import script from "./Demo3.vue?vue&type=script&lang=ts"
export * from "./Demo3.vue?vue&type=script&lang=ts"

import "./Demo3.vue?vue&type=style&index=0&id=96a89fe8&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a89fe8"]])

export default __exports__